// @ts-nocheck
/*
 * Port of views/dashboard/today-running-campaigns.js.
 * API: API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS.
 * Column count preserved: 8 (Campaign ID, Campaign Name, Start Time,
 * Total Numbers, Calls Dialed, Pending Calls, Connected Calls, DTMF Count).
 */
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { friendlyApiError } from '@/utilities/apiErrorMessage';
import type { ColumnDef } from '@tanstack/react-table';
import { getApiCall } from '@/service/httpCall';
import { API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS } from '@/service/url';
import { USER_ROLES } from '@/utilities/constant';
import { Storage } from '@/utilities/setting';
import { Card } from '@/components/ui/card';
import { DataTable } from '@/components/data-table/DataTable';

export default function TodayRunningCampaigns() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = Storage.getItem('user');
      if (!rawUser) return;
      try {
        const user = JSON.parse(rawUser);
        if (user.role) setLoggedInUserRole(user.role);
      } catch (e) {}
    }
    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole == USER_ROLES.CALL_CENTRE_AGENT) return;
    fetchData();

  }, [loggedInUserRole]);

  const fetchData = () => {
    setLoading(true);
    getApiCall(API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS)
      .then((resp) => {
        const formatted = (resp.data || resp).map((item) => ({
          ...item,
          campaignId: item.campaignId?.toString(),
          campaignName: item.campaignName?.toString(),
        }));
        setData(formatted);
      })
      .catch((err) => toast.error(friendlyApiError(err) || 'Failed to fetch data'))
      .finally(() => setLoading(false));
  };

  const columns = useMemo<ColumnDef<any>[]>(
    () => [
      { accessorKey: 'campaignId', header: 'Campaign ID' },
      { accessorKey: 'campaignName', header: 'Campaign Name' },
      { accessorKey: 'startTime', header: 'Start Time' },
      { accessorKey: 'totalNumbers', header: 'Total Numbers' },
      { accessorKey: 'callsDialed', header: 'Calls Dialed' },
      { accessorKey: 'pendingCalls', header: 'Pending Calls' },
      { accessorKey: 'connectedCalls', header: 'Connected Calls' },
      { accessorKey: 'dtmfCount', header: 'DTMF Count' },
    ],
    [],
  );

  return (
    <>
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-foreground">Today's Running Campaigns</span>
          {data.length > 0 && (
            <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-bold text-primary">
              {data.length}
            </span>
          )}
        </div>
      </div>

      <DataTable
        tableId="dashboard.today-running-campaigns"
        columns={columns}
        data={data}
        isLoading={loading}
        searchPlaceholder="Search by campaign name or ID…"
        emptyTitle="No running campaigns"
        emptyDescription="No running campaigns found for today."
        pageSize={10}
        exportFilename="today-running-campaigns.csv"
      />
    </>
  );
}
